import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  Paper,
  Chip,
  Grid,
  IconButton
} from "@material-ui/core";

import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";

const Tags = () => {
  const [tags, setTags] = useState([]);
  const [filteredTags, setFilteredTags] = useState([]);

  const [name, setName] = useState("");
  const [color, setColor] = useState("#3498db");

  const [search, setSearch] = useState("");

  const [editingTag, setEditingTag] = useState(null);

  // 🔹 cargar etiquetas
  const loadTags = async () => {
    try {
      const { data } = await api.get("/tags");
      setTags(data);
      setFilteredTags(data);
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    loadTags();
  }, []);

  // 🔹 búsqueda
  useEffect(() => {
    if (!search) {
      setFilteredTags(tags);
    } else {
      setFilteredTags(
        tags.filter((t) =>
          t.name.toLowerCase().includes(search.toLowerCase())
        )
      );
    }
  }, [search, tags]);

  // 🔹 crear o editar
  const handleSave = async () => {
    if (!name.trim()) {
      toast.warning("Escribe un nombre");
      return;
    }

    try {
      if (editingTag) {
        // 🔥 EDITAR
        const { data } = await api.put(`/tags/${editingTag.id}`, {
          name,
          color
        });

        setTags((prev) =>
          prev.map((t) => (t.id === data.id ? data : t))
        );

        toast.success("Etiqueta actualizada");
      } else {
        // 🔥 CREAR
        const { data } = await api.post("/tags", { name, color });

        setTags((prev) => [...prev, data]);

        toast.success("Etiqueta creada");
      }

      // reset
      setName("");
      setColor("#3498db");
      setEditingTag(null);

    } catch (err) {
      toastError(err);
    }
  };

  // 🔹 eliminar
  const handleDelete = async (id) => {
    if (!window.confirm("¿Eliminar etiqueta?")) return;

    try {
      await api.delete(`/tags/${id}`);
      setTags((prev) => prev.filter((t) => t.id !== id));
      toast.success("Etiqueta eliminada");
    } catch (err) {
      toastError(err);
    }
  };

  // 🔹 editar
  const handleEdit = (tag) => {
    setEditingTag(tag);
    setName(tag.name);
    setColor(tag.color);
  };

  return (
    <Paper style={{ padding: 20 }}>

      <h2>Gestión de Etiquetas</h2>

      {/* 🔍 BUSCADOR */}
      <TextField
        label="Buscar etiqueta"
        fullWidth
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ marginBottom: 20 }}
      />

      {/* 🔥 FORM */}
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={5}>
          <TextField
            label="Nombre"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Grid>

        <Grid item xs={3}>
          <input
            type="color"
            value={color}
            onChange={(e) => setColor(e.target.value)}
            style={{ width: "100%", height: 40 }}
          />
        </Grid>

        <Grid item xs={4}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleSave}
          >
            {editingTag ? "Actualizar" : "Crear"}
          </Button>
        </Grid>
      </Grid>

      {/* 🔥 LISTA */}
      <div style={{ marginTop: 30 }}>

        {filteredTags.map((tag) => (
          <div
            key={tag.id}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 10
            }}
          >
            <Chip
              label={tag.name}
              style={{
                backgroundColor: tag.color,
                color: "#fff",
                marginRight: 10
              }}
            />

            <IconButton onClick={() => handleEdit(tag)}>
              <EditIcon />
            </IconButton>

            <IconButton onClick={() => handleDelete(tag.id)}>
              <DeleteIcon />
            </IconButton>
          </div>
        ))}

      </div>

    </Paper>
  );
};

export default Tags;